module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store_Badge_US.2928664f.svg";